module.exports = __webpack_public_path__ + "img/logo-cabecera-dinapsis.772d65cb.png";